<template lang="html">
    <div class="homepage">
        <Alerts :alert-type="'alert_homepage'"></Alerts>
        <section class="section d-flex justify-content-center desktop-picture">
            <div class="col-lg-9 authorized-distributor-wrapper d-lg-flex d-md-flex d-sm-block" :class="isMobile() ? 'justify-content-center' : 'justify-content-end'">
                <div class="d-flex justify-content-center flex-column">
                    <div class="d-flex justify-content-center">
                        <div class="icon authorized-distributor-icon"></div>
                    </div>
                    <p class="text-center heading-medium">{{ $t('homepage_authorized_distributor') }}</p>
                </div>
            </div>
            <div class="container-medium first-container">
                <h1 class="heading text-center">{{ $t('homepage_buy_tpf_erv') }}</h1>
                <div class="d-lg-flex d-md-flex d-sm-block d-block justify-content-center">
                    <div class="align-items-center text-center purple-btn mobile-padding-bottom">
                        <router-link :to="{name: 'vignette'}" class="d-flex justify-content-end">
                            <button dusk="order-vignette" type="button" class="btn btn-lg btn-homepage btn-purple">{{ $t('i_want_vignette') }}</button>
                        </router-link>
                        <div class="d-flex justify-content-center">
                            <img class="d-flex justify-content-center" src="../media/logo_rovinieta.svg" alt="">
                        </div>
                    </div>
                    <div class="align-items-center text-center purple-btn mobile-padding-bottom">
                        <router-link :to="{name: 'toll'}" class="d-flex justify-content-end">
                            <button dusk="order-bridge-fee" type="button" class="btn btn-lg btn-homepage btn-purple">{{ $t('i_want_toll') }}</button>
                        </router-link>
                        <div class="d-flex justify-content-center">
                            <img class="d-flex justify-content-center" src="../media/logo_taxa_pod.svg" alt="">
                        </div>
                    </div>
                    <div class="align-items-center text-center purple-btn">
                        <a @click.prevent="brokerNetService.goToBrokerNet()" class="d-flex justify-content-end">
                            <button dusk="order-bridge-fee" type="button" class="btn btn-lg btn-homepage btn-purple">{{ $t('i_want_insurance') }}</button>
                        </a>
                        <div class="d-flex justify-content-center">
                            <img class="d-flex justify-content-center" src="../media/logo_tbasigurari.png" height="20px" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="login-home-page justify-content-center d-none d-xl-block d-lg-block" v-if="isLoggedIn == false">
            <LoginComponentHomePage></LoginComponentHomePage>
        </section>

        <section class="grey-bg justify-content-center d-block d-lg-block parteners-section" :class="{'no-padding-top': !isLoggedIn}">
            <div class="container">
                <div class="partners-container">
                    <p class="heading-medium">{{ $t('homepage_partners')  }}</p>
                    <div class="d-flex flex-wrap partners">
                        <a href="https://untrr.ro" class="main-btn fit-content" target="_blank">www.untrr.ro</a>
                        <a href="https://loimacron.eu" class="main-btn fit-content" target="_blank">www.loimacron.eu</a>
                        <a href="https://transmag.ro" class="main-btn fit-content" target="_blank">www.transmag.ro</a>
                        <a href="https://taxa-pod-fetesti.ro" class="main-btn fit-content" target="_blank">www.taxa-pod-fetesti.ro</a>
                        <a href="https://tuneluri.ro" class="main-btn fit-content" target="_blank">www.tuneluri.ro</a>
                        <a href="https://www.tbasigurari.ro/" class="main-btn fit-content" target="_blank">www.tbasigurari.ro</a>
                        <a href="https://a1formular.ro" class="main-btn fit-content" target="_blank">www.a1formular.ro</a>
                        <a href="https://detasaretransport.ro" class="main-btn fit-content" target="_blank">www.detasaretransport.ro</a>
                        <a href="http://asigurarecmr.ro" class="main-btn fit-content" target="_blank">www.asigurarecmr.ro</a>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-wrapper">
            <div class="container container-small">
                <div class="steps">
                    <p class="heading-medium text-center">{{ $t('homepage_ready_for_road') }}</p>
                    <div class="steps-wrapper d-flex justify-content-center">
                        <div class="add-cart-wrapper">
                            <div class="d-flex justify-content-center">
                                <div class="icon add-cart-icon"></div>
                            </div>
                            <p class="heading-small text-center">{{ $t('homepage_order') }}</p>
                        </div>
                        <div class="hr-line-wrapper"><hr></div>

                        <div class="card-payment-wrapper text-center">
                            <div class="d-flex justify-content-center">
                               <div class="icon card-payment-icon"></div>
                            </div>
                            <p class="heading-small text-center">{{ $t('homepage_payment') }}</p>
                        </div>
                        <div class="hr-line-wrapper"><hr></div>

                        <div class="semafor-wrapper text-center">
                            <div class="d-flex justify-content-center">
                                <div class="icon semafor-icon"></div>
                            </div>
                            <p class="heading-small text-center">{{ $t('homepage_drive') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-wrapper pt-0" v-if="isMobile()">
            <div class="container container-medium">
                <div class="benefits">
                    <p class="text-center heading-medium">{{ $t('homepage_your_advantages') }}</p>
                    <carousel :per-page="1" :mouse-drag="false">
                        <slide>
                            <div class="row steps-wrapper d-lg-flex d-md-flex d-sm-block d-block justify-content-center">
                                <div class="col-lg-4 add-cart-wrapper text-center">
                                    <div class="d-flex justify-content-center">
                                        <div class="icon verifici-valabilitate-icon"></div>
                                    </div>
                                    <h3 class="heading heading-small pt-2 check-validity">{{ $t('homepage_vignette_availability') }}</h3>
                                    <p class="reading">{{ $t('homepage_vignette_availability_description_1') }}<br><a @click.prevent="openVerifyVignetteModal" href="#"><strong>{{ $t('homepage_vignette_availability_description_2') }}</strong></a></p>
                                </div>

                                <div class="col-lg-4 card-payment-wrapper text-center">
                                    <div class="d-flex justify-content-center">
                                    <div class="icon salveaza-datele-icon"></div>
                                    </div>
                                    <h3 class="heading heading-small">{{ $t('homepage_save_data') }}</h3>
                                    <p class="reading">{{ $t('homepage_save_data_description') }}</p>
                                </div>

                                <div class="col-lg-4 semafor-wrapper text-center">
                                    <div class="d-flex justify-content-center">
                                        <div class="icon livrare-email-sms-icon"></div>
                                    </div>
                                    <h3 class="heading heading-small">{{ $t('homepage_sms_email_delivery') }}</h3>
                                    <p class="reading">{{ $t('homepage_sms_email_delivery_description') }}</p>
                                </div>
                            </div>
                        </slide>
                        <slide>
                            <div class="steps-wrapper d-lg-flex d-md-flex d-sm-block d-block justify-content-center">
                                <div class="col-lg-4 add-cart-wrapper text-center">
                                    <div class="d-flex justify-content-center">
                                        <div class="icon card-icon"></div>
                                        <div class="icon invoice-icon" style="margin-left: -20px;"></div>
                                    </div>
                                    <h3 class="heading heading-small">{{ $t('homepage_card_or_op') }}</h3>
                                    <p class="reading">{{ $t('homepage_card_or_op_description') }}</p>
                                </div>

                                <div class="col-lg-4 card-payment-wrapper text-center">
                                    <div class="d-flex justify-content-center">
                                    <div class="icon notificare-expirare-icon"></div>
                                    </div>
                                    <h3 class="heading heading-small">{{ $t('homepage_notify_expiry') }}</h3>
                                    <p class="reading">{{ $t('homepage_notify_expiry_description') }}</p>
                                </div>

                                <div class="col-lg-4 semafor-wrapper text-center">
                                    <div class="d-flex justify-content-center">
                                        <div class="icon servicii-profesioniste-icon"></div>
                                    </div>
                                    <h3 class="heading heading-small">{{ $t('homepage_professional_services') }}</h3>
                                    <p class="reading">{{ $t('homepage_professional_services_description') }}</p>
                                </div>
                            </div>
                        </slide>
                    </carousel>
                </div>
            </div>
        </section>
        <section class="section-wrapper pt-0" v-if="!isMobile()">
            <div class="container container-medium">
                <div class="benefits">
                    <p class="text-center heading-medium">{{ $t('homepage_your_advantages') }}</p>
                    <div class="row steps-wrapper d-lg-flex d-md-flex d-sm-block d-block justify-content-center">
                        <div class="col-lg-4 add-cart-wrapper text-center">
                            <div class="d-flex justify-content-center">
                                <div class="icon verifici-valabilitate-icon"></div>
                            </div>
                            <h3 class="heading heading-small check-validity">{{ $t('homepage_vignette_availability') }}</h3>
                            <p class="reading">{{ $t('homepage_vignette_availability_description_1') }}<br><a @click.prevent="openVerifyVignetteModal" href="#"><strong>{{ $t('homepage_vignette_availability_description_2') }}</strong></a></p>
                        </div>

                        <div class="col-lg-4 card-payment-wrapper text-center">
                            <div class="d-flex justify-content-center">
                            <div class="icon salveaza-datele-icon"></div>
                            </div>
                            <h3 class="heading heading-small">{{ $t('homepage_save_data') }}</h3>
                            <p class="reading">{{ $t('homepage_save_data_description') }}</p>
                        </div>

                        <div class="col-lg-4 semafor-wrapper text-center">
                            <div class="d-flex justify-content-center">
                                <div class="icon livrare-email-sms-icon"></div>
                            </div>
                            <h3 class="heading heading-small">{{ $t('homepage_sms_email_delivery') }}</h3>
                            <p class="reading">{{ $t('homepage_sms_email_delivery_description') }}</p>
                        </div>
                    </div>
                    <div class="steps-wrapper d-lg-flex d-md-flex d-sm-block d-block justify-content-center">
                        <div class="col-lg-4 add-cart-wrapper text-center">
                            <div class="d-flex justify-content-center">
                                <div class="icon card-icon"></div>
                                <div class="icon invoice-icon" style="margin-left: -20px;"></div>
                            </div>
                            <h3 class="heading heading-small">{{ $t('homepage_card_or_op') }}</h3>
                            <p class="reading">{{ $t('homepage_card_or_op_description') }}</p>
                        </div>

                        <div class="col-lg-4 card-payment-wrapper text-center">
                            <div class="d-flex justify-content-center">
                            <div class="icon notificare-expirare-icon"></div>
                            </div>
                            <h3 class="heading heading-small">{{ $t('homepage_notify_expiry') }}</h3>
                            <p class="reading">{{ $t('homepage_notify_expiry_description') }}</p>
                        </div>

                        <div class="col-lg-4 semafor-wrapper text-center">
                            <div class="d-flex justify-content-center">
                                <div class="icon servicii-profesioniste-icon"></div>
                            </div>
                            <h3 class="heading heading-small">{{ $t('homepage_professional_services') }}</h3>
                            <p class="reading">{{ $t('homepage_professional_services_description') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="container-fluid section-benefits d-lg-flex d-md-flex d-sm-block d-block">
            <div class="row">
                <div class="col-lg-6 col-img pl-0 pr-0">
                    <img src="../media/beneficii.png" alt=""/>
                </div>
                <div class="benefits-wrapper col-lg-6 pl-0 pr-0">
                    <div class="wrapper-inner">
                        <p class="heading-medium">{{ $t('bp_company_advantages') }}</p>
                        <div class="inner col-xl-6 p-0">
                            <div class="p-small">
                                <strong>{{ $t('bp_import_you_cars_through_excel') }}</strong> {{ $t('homepage_online_assistance') }}
                            </div>
                            <div class="mt-4" :class="isMobile() ? 'justify-content-center' : ''">
                                <router-link :to="{name: 'company-advanges'}" class="main-btn">{{ $t('homepage_discover_all_benefits') }}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-distribuitor">
            <div class="container container-medium">
                <p class="heading-medium text-center">{{ $t('homepage_discover_all_benefits') }}</p>
                <div class="align-items-center text-center">
                    <div class="d-flex justify-content-center">
                        <div class="icon finder-icon"></div>
                    </div>
                    <p class="mt-1 heading-small">{{ $t('homepage_distribution_points') }}</p>
                    <div class="d-flex justify-content-center">
                        <p class="puncte-teritoriale-text">
                            {{ $t('homepage_authorized_distributor_2') }}
                        </p>
                    </div>
                    <p>
                        <strong>
                            <router-link :to="{name: 'distribution'}">
                                {{ $t('homepage_distribution_points_description') }}
                            </router-link>
                        </strong>
                    </p>
                </div>
            </div>
        </section>

        <section class="section-frequent-questions">
            <div class="container container-small">
                <p class="text-center pb-3 heading-medium">{{ $t('homepage_frequent_questions') }}</p>
                <FrequentQuestionComponent :count="3" :homepage="true"></FrequentQuestionComponent>
                <p><strong><router-link :to="{name: 'questions'}">{{ $t('homepage_frequent_questions_description') }}</router-link></strong></p>
            </div>
        </section>
    </div>
</template>

<script>
    import Header from './Header.vue';
    import FrequentQuestionComponent from './FrequentQuestionComponent.vue';
    import CartSummary from './order/CartSummary.vue';
    import LoginComponentHomePage from './authentication/LoginComponentHomePage.vue';
    import { Carousel, Slide } from 'vue-carousel';
    import { mapState, mapGetters } from 'vuex';
    import Alerts from './snippets/Alerts.vue';
    import { BrokerNetService } from '../services/BrokerNetService';

    export default {
        name: 'Homepage',
        components: {
            Header,
            CartSummary,
            LoginComponentHomePage,
            FrequentQuestionComponent,
            Carousel,
            Slide,
            Alerts
        },
        data() {
            return {
                brokerNetService: null
            }
        },
        props: {
        },
        computed: {
            ...mapState('auth', [
                 'isLoggedIn'
            ]),
            ...mapGetters('cart', [
                'cartCount',
            ]),
        },
        mounted() {
            this.brokerNetService = new BrokerNetService();
        },
        methods: {
            displayContent(contentId){
                $(`#${contentId}`).toggle();
            },
            openVerifyVignetteModal() {
                this.$eventBus.$emit('openVerifyVignette');
            }
        }
    }
</script>

<style lang="scss" scoped>

    $lightgrey: lightgrey;
    $green: #59af54;
    $dark: #272D37;
    $accent-color: #3F24E2;

    .wrapper-inner {
        padding-left: 20px;
        padding-right: 20px;
        .inner {
           .link {
                margin: 10px 0 35px 0;
           }
        }
    }
    .card {
        background: #272D37;
        height: 148px;
        cursor: pointer;

        img {
            max-height: 25px;
        }

        a {
            display: block;
            width: 100%;
            padding: 0 15px;
        }
    }
    .mobile-picture {
        background-image: url('../media/new_bg-m.jpg');
    }
    .desktop-picture {
        .authorized-distributor-wrapper, .first-container {
            z-index: 100;
        }
        background-image: url('../media/new-header.jpg');
        position: relative;
        &::after {
            opacity: 0.3;
            content: ' ';
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: #111914;
        }
    }
    .section {
        background-position: bottom;
        background-repeat: no-repeat;
        padding-top: 187px;
        padding-bottom: 127px;

        .first-container {
            max-width: 855px;
            padding: 0px 20px;
            .purple-btn {
                margin: 0 14px;
                > a {
                    padding-bottom: 11px;
                }
            }
        }

        h1 {
            margin-bottom: 61px;
        }
        a {
            color: white;
            text-decoration: none;
            &:hover{
                text-decoration: none;
                color: white;
            }
        }
        .authorized-distributor-wrapper {
            position: absolute;
            top: 71px;
            padding: 0 20px 0 0;
            max-width: 1390px;
            > div {
                max-width: 127px;
            }
            p {
                color: white;
                font-weight: 600;
                font-size: 12px;
            }
            .authorized-distributor-icon {
                width: 28px !important;
                height: 31px !important;
            }
        }

        .btn-homepage {
            height: 82px;
            width: 291.6px;
            color: white;
            &:hover {
                text-decoration: none;
                color: white;
            }
        }
    }
    .section-wrapper {
        width: 100%;
        background-color: #FAF9F6;
        padding-top: 75px;
        padding-bottom: 75px;
        .steps {

            .steps-wrapper {

                .hr-line-wrapper {
                    flex: 1;
                    padding-top: 60px;

                    hr {
                        border-top: 1px solid #0F2443;
                    }
                }

                .add-cart-wrapper, .card-payment-wrapper, .semafor-wrapper {
                    flex: 1;
                    padding: 50px 0 0 0;
                    display: flex;
                    flex-flow: column;
                    justify-content: space-between;

                    @media only screen and (min-width: 768px) {
                        p {
                            margin: 10px 0 0 0;
                        }
                    }
                }

                .card-payment-wrapper {
                    @media only screen and (min-width: 768px) {
                        p {
                            margin: 22px 0 0 0;
                        }
                    }
                }

                .add-cart-wrapper {
                    @media only screen and (min-width: 768px) {
                        p {
                            margin: 15px 0 0 0;
                        }
                    }
                }
            }

        }
        .benefits {

            .steps-wrapper {
                @media only screen and (max-width: 768px) {
                    padding: 0px 30px;

                    h3 {
                        margin-top: 12px;
                    }
                }

                .add-cart-wrapper, .card-payment-wrapper, .semafor-wrapper {
                    flex: 1;
                    padding: 35px 20px 35px 20px;
                }

                .add-cart-wrapper{

                    @media only screen and (min-width: 768px) {
                        p {
                            margin: 15px 0 0 0;
                        }
                    }
                }

                .semafor-wrapper {

                    @media only screen and (min-width: 768px) {
                        p {
                            margin: 19px 0 0 0;
                        }
                    }
                }

                @media only screen and (max-width: 768px) {
                  .check-validity {
                    margin-top: 20px!important;
                  }
                }

                .check-validity {
                    line-height: 1.5;
                    margin-top: 30px;
                }
            }
        }
    }
    .section-benefits {
        background-color: #EDE9F2;
        padding-top: 20px;
        padding-bottom: 40px;

        .col-img {
            padding-right: 30px;
        }

        .benefits-wrapper {
            padding-top: 5%;
        }
    }
    .section-distribuitor {
        padding-top: 110px;
        padding-bottom: 50px;
        background-color: #FAF9F6;
    }

    .login-home-page {
        background-color: #EEEDEC;
        padding: 90px 15px 90px 15px;
    }

    .grey-bg {
        background-color: #EEEDEC;
        padding: 90px 15px 90px 15px;
    }
    
    @media only screen and (min-width: 992px) {
        .parteners-section {
            &.no-padding-top {
                padding-top: 0px;
            }
        }
    }

    .fit-content {
        width: fit-content;
    }

    .partners-container {
        padding: 0px 20px;
        
        .partners {
            gap: 20px;
        }
    }

    .authorized-distributor-wrapper {

        p {
            margin: 0;
            margin-top: 5px;
        }
    }

    @media only screen and (max-width: 992px) {
        .parteners-section {

            .partners-container {
                padding: 0px;

                .heading-medium {
                    text-align: center;
                }

                .partners {
                    gap: 10px;
                    
                    .main-btn {
                        width: 100%;
                        font-size: 12px;
                    }
                }
            }

            
        }

        .section-benefits {
            padding-bottom: 60px;

            .inner {

                .link {
                    margin: 10px 0 15px 0;
                }
            }
        }
    }

    @media only screen and (max-width: 768px) {
        .section {
            padding-top: 140px;
            padding-bottom: 50px;
            background-size: cover;

            .authorized-distributor-wrapper {
                top: 50px;
                padding: 0;

                .authorized-distributor-icon {
                    width: 18pt !important;
                    height: 16pt !important;
                }

                > div {
                    max-width: 130px;
                    margin: 0 auto;
                }
            }

            .btn-homepage {
                width: 100%;
            }

            a {
                text-decoration: none;
                font-size: 22px;

                &:hover{
                    text-decoration: none;
                }

                .btn-purple{
                    height: 60px;
                    font-size: 18px;
                }
            }

            .first-container {

                .purple-btn {
                    margin: 0;

                    &.mobile-padding-bottom{
                        padding-bottom: 35px;
                    }

                    >a {
                        padding-bottom: 15px;
                    }
                }

                h1 {
                    margin-bottom: 25px;
                    line-height: 35px;
                }
            }
        }

        .steps-wrapper {

            .hr-line-wrapper {
                padding-top: 40px !important;

            }
            .add-cart-wrapper, .card-payment-wrapper, .semafor-wrapper {
                padding: 30px 0 0 0 !important;
            }
        }

        .section-benefits {

            .benefits-wrapper {

                p {
                    width: 100%;
                }

                .check-validity {
                  margin-top: 20px;
                }
            }
        }

        .benefits {

            p {
                margin: 0;
            }
        }

        .section-wrapper {
            padding: 40px 0;
        }

        .section-distribuitor {
            padding-top: 70px;
        }
    }
</style>
